export const questionnaires = [
  {
    result: 42,
    number: 1,
    filters: "Biologia",
    completedAt: "03/01/2019 - 10:00",
    count: 50,
    correct: 21,
    averageUntilThis: 0.7
  },
  {
    result: 50,
    number: 2,
    filters: "2019, Física",
    completedAt: "04/01/2019 - 12:13",
    count: 10,
    correct: 5,
    averageUntilThis: 0.6
  },
  {
    result: 60,
    number: 3,
    filters: "Filosofia",
    completedAt: "10/01/2019 - 14:22",
    count: 20,
    correct: 12,
    averageUntilThis: 0.8
  },
  {
    result: 55,
    number: 4,
    filters: "2020, Primeiro dia",
    completedAt: "14/01/2019 - 15:05",
    count: 95,
    correct: 52,
    averageUntilThis: 0.76
  },
  {
    result: 71,
    number: 5,
    filters: "2020, Segundo dia",
    completedAt: "02/02/2019 - 20:47",
    count: 95,
    correct: 67,
    averageUntilThis: 0.72
  }
];

export const subjects = [
  { name: "Arte", count: 51, correct: 6, answered: 14 },
  { name: "Matemática", count: 473, correct: 2, answered: 8 },
  { name: "Física", count: 129, correct: 1, answered: 4 },
  { name: "História", count: 181, correct: 1, answered: 2 },
  { name: "Química", count: 139, correct: 1, answered: 2 },
  { name: "Português", count: 598, correct: 1, answered: 3 },
  { name: "Geografia", count: 235, correct: 1, answered: 4 },
  { name: "Espanhol", count: 59, correct: 2, answered: 3 },
  { name: "Literatura", count: 65, correct: 2, answered: 5 },
  { name: "Biologia", count: 108, correct: 1, answered: 2 },
  { name: "Sociologia", count: 91, correct: 3, answered: 4 },
  { name: "Inglês", count: 73, correct: 5, answered: 6 },
  { name: "Filosofia", count: 72, correct: 4, answered: 5 }
];

export const speed = {
  averageResolutionTime: 74,
  subjects: [
    {
      averageResolutionTime: 98.91728305778034,
      name: "Física",
      questionsCount: "579",
      slug: "fisica"
    },
    {
      averageResolutionTime: 91.24606099806954,
      name: "Geografia",
      questionsCount: "630",
      slug: "geografia"
    },
    {
      averageResolutionTime: 87.28261171064618,
      name: "Literatura",
      questionsCount: "607",
      slug: "literatura"
    },
    {
      averageResolutionTime: 83.9390409169994,
      name: "Inglês",
      questionsCount: "394",
      slug: "ingles"
    },
    {
      averageResolutionTime: 79.08427731741446,
      name: "Biologia",
      questionsCount: "726",
      slug: "biologia"
    },
    {
      averageResolutionTime: 75.59205879095958,
      name: "História",
      questionsCount: "689",
      slug: "historia"
    },
    {
      averageResolutionTime: 73.83491042568056,
      name: "Química",
      questionsCount: "551",
      slug: "quimica"
    },
    {
      averageResolutionTime: 72.49528248994002,
      name: "Matemática",
      questionsCount: "965",
      slug: "matematica"
    },
    {
      averageResolutionTime: 53.29067380497783,
      name: "Português",
      questionsCount: "867",
      slug: "portugues"
    },
    {
      averageResolutionTime: 43.05095802592592,
      name: "Espanhol",
      questionsCount: "21",
      slug: "espanhol"
    },
    {
      averageResolutionTime: 41.96555741275308,
      name: "Filosofia",
      questionsCount: "247",
      slug: "filosofia"
    },
    {
      averageResolutionTime: 41.06780982712212,
      name: "Arte",
      questionsCount: "176",
      slug: "arte"
    },
    {
      averageResolutionTime: 38.49144819893098,
      name: "Sociologia",
      questionsCount: "223",
      slug: "sociologia"
    }
  ]
};
